__turbopack_context__.v({
  "char": "ascii-background-module__BXF32q__char",
  "container": "ascii-background-module__BXF32q__container",
  "flicker": "ascii-background-module__BXF32q__flicker",
  "wrapper": "ascii-background-module__BXF32q__wrapper",
});
